/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalDiagnosisHostStatus
 */
export interface TerminalDiagnosisHostStatus {
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisHostStatus
     */
    isReachable: boolean;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisHostStatus
     */
    acquirerId?: string | null;
}

/**
 * Check if a given object implements the TerminalDiagnosisHostStatus interface.
 */
export function instanceOfTerminalDiagnosisHostStatus(value: object): value is TerminalDiagnosisHostStatus {
    if (!('isReachable' in value) || value['isReachable'] === undefined) return false;
    return true;
}

export function TerminalDiagnosisHostStatusFromJSON(json: any): TerminalDiagnosisHostStatus {
    return TerminalDiagnosisHostStatusFromJSONTyped(json, false);
}

export function TerminalDiagnosisHostStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDiagnosisHostStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'isReachable': json['isReachable'],
        'acquirerId': json['acquirerId'] === undefined ? undefined : json['acquirerId'] === null ? null : json['acquirerId'],
    };
}

export function TerminalDiagnosisHostStatusToJSON(json: any): TerminalDiagnosisHostStatus {
    return TerminalDiagnosisHostStatusToJSONTyped(json, false);
}

export function TerminalDiagnosisHostStatusToJSONTyped(value?: TerminalDiagnosisHostStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isReachable': value['isReachable'],
        'acquirerId': value['acquirerId'],
    };
}

